export const IconButton = {
    MuiIconButton: {
        defaultProps: {
            disableFocusRipple: true
        },
        styleOverrides: {
            root: ({ theme })=>({
                    color: "#000000de",
                    ["&:hover"]: {
                        color: theme.palette.primary.main,
                        background: "000000"
                    },
                    ["&:focus-visible"]: {
                        color: theme.palette.primary.main
                    }
                })
        }
    }
};

//# sourceMappingURL=IconButton.js.map